export default {
  namespaced: true,
  state: {
    local: {},
    remote: {},
    loaded: false,
  },
  mutations: {

    setLocal(state, data) {
      state.local = data;
    },

    setRemote(state, data) {
      state.remote = data;
    },

    setRemoteItem(state, item) {
      state.remote[item.key] = item.value;
    },

    setLocalItem(state, item) {
      state.local[item.key] = item.value;
    },

    load(state) {
      state.loaded = true;
    },
  },
  actions: {


    setItem({ commit, state }, params) {
      if(params.type === 'local') {
        commit('setLocalItem', params.item);
        localStorage.setItem('user-settings', JSON.stringify(state.local));
      } else {
        commit('setRemoteItem', params.item);
        // TODO save to server
      }
    },
    

    updateData({ commit, state }) {
      let local = localStorage.getItem('user-settings');
      commit('setLocal', local ? JSON.parse(local) : {});

      commit('setRemote', {}); // TODO connect to server
      commit('load');
    },
  },
  getters: {

    data(state) {
      return {
        ...state.remote,
        ...state.local,
      }
    },

    local(state) {
      return state.local;
    },

    remote(state) {
      return state.remote;
    },

    isLoaded(state) {
      return state.loaded;
    }
  }
}
